import React from 'react';
import styled, {css} from 'styled-components';
import PropTypes from 'prop-types';
import {pickColor, validColorValues} from '@nib/layout';

/* Sizing scale */
const sizes = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
  xxl: 96,
  xxxl: 128
};

const isNamedColor = (color) => {
  if (!color) return false;
  if (validColorValues.includes(color)) {
    return true;
  }
  return false;
};

const setColor = (props) => {
  if (isNamedColor(props.fill)) {
    return css`
      color: ${pickColor(props.fill)};
    `;
  }
  return css`
    color: ${props.fill};
  `;
};

const Svg = styled(({fill, ...rest}) => <svg {...rest}></svg>)`
  display: inline-block;
  ${props => setColor(props)};
`;

const getSize = size => {
  return sizes[size] || (isNaN(size) ? null : size);
}

const BaseIcon = ({children, size, ...otherProps}) => (
  <Svg role="img" viewBox="0 0 24 24" height={getSize(size)} width={getSize(size)} aria-hidden={true} {...otherProps}>
    {children}
  </Svg>
);

BaseIcon.displayName = 'BaseIcon';

BaseIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(sizes)), PropTypes.number])
}

export default BaseIcon;
